export const SCREEN_SIZE = {
  phone: 400,
  tablet: 900,
};
